import { createFileRoute } from '@tanstack/react-router'
import { CookiesDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import CookiePreferencesDialog from '@/routes/_app/-dialogs/cookie-preferences'

export const Route = createFileRoute('/@modal/cookies')({
  pendingComponent: CookiesDialogPending,
  component: CookiePreferencesSlot,
})

function CookiePreferencesSlot() {
  const slot = useModalSlot(Route)
  return <CookiePreferencesDialog {...slot} />
}
